import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { IMAGE_URL } from "../../utils/constant";
import {
  getUserById,
  updateUserById,
  getLogedInUser, twoFactorCode
} from "../../actions/users";
import { resetPassword } from "../../actions/auth";
import { useSelector, useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import $ from "jquery";
import { countryCodes } from "../../utils/countryCode";
import img2 from "../../assets/images/dummyImage.png";

var Model = require("../information/model");

const PageProfile = (props) => {
  let profilePic = img2;
  if (
    JSON.parse(localStorage.getItem("user")).logo &&
    JSON.parse(localStorage.getItem("user")).logo != ""
  )
    profilePic = `${IMAGE_URL}${JSON.parse(localStorage.getItem("user")).logo}`;
  const data = useSelector((state) => state?.users?.logedInUser?.data);
  const userQR = useSelector((state) => state?.users?.userQrCode?.data);
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [primaryContactName, setPrimaryContactName] = useState("");
  const [phone, setPhone] = useState("");
  const [isModal, setModal] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [logo, setLogo] = useState("");
  const [QRCode, setQRCode] = useState(true);
  const [verificationToken, setVerificationToken] = useState("");

  useEffect(() => {
    setPrimaryContactName(data?.fullName);
    setEmail(data?.email);
    setPhone(data?.contact);
    setCountryCode(data?.countryCode);
    setLogo(data?.logo);
  }, [data]);

  useEffect(() => {
    getLogedInUser("", dispatch);
    twoFactorCode("", dispatch)
  }, []);

  const submit = (e) => {
    e.preventDefault();
    updateUserById({
      id: data?.organisationId?._id,
      fullName: primaryContactName,
      email: email,
      countryCode: countryCode,
      contact: phone,
      logo: logo,
      redirect: true,
    }, dispatch);
  };

  const handleLogoChange = (e) => {
    Model.default.saveLogo(e.target.files[0]).then((response) => {
      if (!response.error) {
              let logo = response.data;
      setLogo(logo);
      }
    });
  };

  const enabledTwoFactor = (e) => {
    if (verificationToken == "") {
      toastr.error("Error", "Please enter two factor code.");
      return false;
    }
    Model.default.enableTwoFactor(verificationToken, userQR.encodedTotpSecret).then((response) => {
      if (!response.error) {
        setQRCode(false);
        toastr.success("Success", "Two factor enabled.");
        // let orgLogo = response.data;
        // setLogo(orgLogo);
      }
    });
  }

  const showPassword = (e) => {
    document
      .getElementById("current_password")
      .setAttribute(
        "type",
        document.getElementById("current_password").getAttribute("type") ===
          "password"
          ? "text"
          : "password"
      );
    document
      .getElementById("toggle1")
      .setAttribute(
        "class",
        document.getElementById("current_password").getAttribute("type") ===
          "password"
          ? "toggle-password fa fa-eye"
          : "toggle-password fa fa-eye-slash"
      );
  };
  const showPassword1 = (e) => {
    document
      .getElementById("new_password")
      .setAttribute(
        "type",
        document.getElementById("new_password").getAttribute("type") ===
          "password"
          ? "text"
          : "password"
      );
    document
      .getElementById("toggle2")
      .setAttribute(
        "class",
        document.getElementById("new_password").getAttribute("type") ===
          "password"
          ? "toggle-password fa fa-eye"
          : "toggle-password fa fa-eye-slash"
      );
  };
  const showPassword2 = (e) => {
    document
      .getElementById("confirm_password")
      .setAttribute(
        "type",
        document.getElementById("confirm_password").getAttribute("type") ===
          "password"
          ? "text"
          : "password"
      );
    document
      .getElementById("toggle3")
      .setAttribute(
        "class",
        document.getElementById("confirm_password").getAttribute("type") ===
          "password"
          ? "toggle-password fa fa-eye"
          : "toggle-password fa fa-eye-slash"
      );
  };

  const updatePassword = (e) => {
    e.preventDefault();
    let current_password = $("#current_password").val();
    let new_password = $("#new_password").val();
    let confirm_password = $("#confirm_password").val();
    if (!current_password) {
      toastr.error("Error", "Please enter current password");
      return false;
    }
    if (!new_password) {
      toastr.error("Error", "Please enter new password");
      return false;
    }
    if (!confirm_password) {
      toastr.error("Error", "Please enter confirm password");
      return false;
    }
    if (new_password != confirm_password) {
      toastr.error("Error", "Password mismatch.");
      return false;
    }

    resetPassword(
      {
        password: current_password,
        confirmPassword: confirm_password,
        redirect: true,
        propRedirect: props,
      },
      dispatch
    );
  };
  return (
    <>
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h2 className="welcome-text">User Profile</h2>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/" className="welcome-textSmall">Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                    style={{ color: "white" }}
                  >
                    Profile
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-md-12">
            <div className="card mb-2">
              <div className="body">
                <h6 className="welcome-text mb-4">My Profile Information</h6>
                <div className="row clearfix">
                  <div className="col-md-12">
                    <div className="myProfileInfo">
                      <div className="d-flex align-items-center">
                        <img src={profilePic} alt="profile" className="img-fluid" />
                        <div className="myProfileInfoText">
                          <h5>{data?.fullName}</h5>
                          <p>{data?.email} | {data?.countryCode} {data?.contact}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="card mb-2">
              <div className="body" style={{ minHeight: "266px" }}>
                <h6 className="welcome-textsmall mb-4">Edit Profile</h6>
                <div className="row clearfix">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control formControlProfile"
                        placeholder="Full Name"
                        value={primaryContactName}
                        onChange={(e) =>
                          setPrimaryContactName(e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control formControlProfile"
                        placeholder="Email Address"
                        disabled={true}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      // defaultValue={
                      //   JSON.parse(localStorage.getItem("user")).email
                      // }
                      />
                    </div>
                  </div>
                </div>
                <div className="row clearfix">
                  <div className="col-lg-6 col-md-12">
                    <div className="form-group" style={{ display: "flex" }}>
                      <select
                        className="form-control formControlProfile"
                        value={countryCode}
                        onChange={(e) => setCountryCode(e.target.value)}
                        style={{ width: "100px" }}
                      >
                        {countryCodes?.map((val) => {
                          return (
                            <option value={val.dial_code}>
                              {val.name}
                            </option>
                          );
                        })}
                      </select>
                      <input
                        type="number"
                        className="form-control formControlProfile"
                        placeholder="Contact Number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="custom-file custom-file-profile">
                      <input
                        type="file"
                        className="custom-file-input form-control formControlProfile"
                        id="inputGroupFile01"
                        onChange={handleLogoChange}
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="inputGroupFile01"
                      >
                        Upload Profile Picture
                      </label>
                    </div>
                  </div>
                </div>
                <br />
                <button
                  type="button"
                  style={{ color: "black", fontWeight: "bold" }}
                  className="btn btn-round btn-primary mr-1"
                  onClick={submit}
                >
                  Update
                </button>{" "}
                &nbsp;&nbsp;
                <button type="button" className="btn btn-round btn-default">
                  Cancel
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="card mb-2">
              <div className="body">
                <div className="row clearfix">
                  <div className="col-lg-12 col-md-12">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="welcome-textsmall mb-0">Password</h6>
                      <Link to="#" className="link16Px" onClick={() => setModal("Form Wizard modal")}>Change Password</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {userQR && !userQR?.generated && QRCode && (
          <div className="row clearfix">
            <div className="col-md-12">

              <div className="row clearfix">
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="card">
                    <div className="body" style={{ minHeight: "266px" }}>
                      <center>
                        <h4 style={{ marginBottom: "30px" }}>2 Step Verification</h4>
                        <div className="row clearfix">
                          <div className="col-lg-12 col-md-12">
                            <h6 style={{ marginBottom: "30px" }}>Scan this code with Google Authenticator</h6>
                            <img style={{ marginBottom: "30px" }} src={`data:image/png;base64,${userQR?.totpSecretQRCode}`} width="150px" />
                          </div>
                          <div className="col-lg-6 col-md-6" style={{ margin: "auto" }}>
                            <h6 style={{ marginBottom: "20px" }}>Enter the verification code <br />generated by your mobile application.</h6>
                            <input type="text" className="form-control formControlProfile"
                              placeholder="Token"
                              // disabled={true}
                              // value={email}
                              onChange={(e) => setVerificationToken(e.target.value)}></input><br />
                            <button
                              type="button"
                              onClick={enabledTwoFactor}
                              style={{ color: "black", fontWeight: "bold" }}
                              className="btn btn-round btn-primary mr-1">
                              VERIFY
                            </button>
                          </div>
                        </div>
                      </center>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-md" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Change Password
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setModal("")}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card mb-3">
                    <div className="form-group">
                      <label>Current Password</label>
                      <input
                        type="password"
                        className="form-control formControlProfile"
                        placeholder="Current Password"
                        id="current_password"
                      />
                      <span
                        id="toggle1"
                        style={{ marginRight: "8px", marginTop: "-16px" }}
                        onClick={(e) => showPassword(e)}
                        className="fa fa-eye toggle-password"
                      ></span>
                    </div>
                    <div className="form-group">
                      <label>New Password</label>
                      <input
                        type="password"
                        className="form-control formControlProfile"
                        placeholder="New Password"
                        id="new_password"
                      />
                      <span
                        id="toggle2"
                        style={{ marginRight: "8px", marginTop: "-16px" }}
                        onClick={(e) => showPassword1(e)}
                        className="fa fa-eye toggle-password"
                      ></span>
                    </div>
                    <div className="form-group">
                      <label>Confirm Password</label>
                      <input
                        type="password"
                        className="form-control formControlProfile"
                        placeholder="Confirm New Password"
                        id="confirm_password"
                      />
                      <span
                        id="toggle3"
                        style={{ marginRight: "8px", marginTop: "-16px" }}
                        onClick={(e) => showPassword2(e)}
                        className="fa fa-eye toggle-password"
                      ></span>
                    </div>
                    <div className="d-flex align-items-center justify-content-center mt-4">
                      <button type="button" className="btn btn-round btn-default"
                        onClick={() => setModal("")}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={updatePassword}
                        className="btn btn-round btn-primary mr-1">
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PageProfile;
